/* eslint-disable @typescript-eslint/naming-convention */

import type { CountryListItem, Partner } from '@app/generated/api/model'

import { newPartner } from './partner'
import { Place } from './place'
import { ProjectContract } from './project-contract'

export interface BALZACBook {
  id?: number
  country: Pick<CountryListItem, 'id' | 'code_iso' | 'code_iso_2' | 'label_en' | 'label_fr'> | null
  currency: number| null
  partner: Partner | null
  place?: Place
  project_contract?: ProjectContract
  premises?: number

  account_number?: string
  status?: string
  type?: string
  cash_type?: string
  interface?: string
  saga_name?: string
  label?: string
  comments?: string
  created_at?: string
}

export function newBALZACBook (): BALZACBook {
  return {
    country: null,
    currency: null,
    partner: newPartner(),
  }
}
